import React from "react";
import Title from "../layouts/Title";
import ProjectsCard from "./ProjectsCard";
// import ProjectsCardedit from "./ProjectsCardedit";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 xl:gap-20">

      <ProjectsCard
          title="buy sell cars & property"
          des="Buy, Sell, and Own Your Dream Cars and Homes buyers and sellers of cars and properties."
          src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/buyandsell.png"
        />
        <ProjectsCard
          title="ChatZone App"
          des="Connect, Share, and Chat with Friends and Family allows users to connect friends & family."
          src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/socil.png"
        />
        <ProjectsCard
          title="Music app"
          des="Discover, Stream, and Download Your Favorite Music stream favorite songs & download music."
          src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/socio.png"
        />
      
        <ProjectsCard
          title="Food Recipe App"
          des="The app allows users  information recto ipes, including ingredients, & cooking instructions. "
          src="https://raw.githubusercontent.com/AsmaJalal/My_Recipe_App_React_Native/main/src/Screenshots/Animation.gif"
        />
        <ProjectsCard
          title="SearchKAro Mobile App"
          des="finding what you need is faster. Categorized searches help you locate products, services."
          src="https://raw.githubusercontent.com/AsmaJalal/SearchKaro/main/searchkro.gif"
        />

        <ProjectsCard
          title="VPN Mobile App"
          des="VPN mobile app for smartphones enables users to establish a secure and encrypted connection."
          src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/vpn.gif"
        />
        <ProjectsCard
          title="Full-Stack MyCarmedics"
          des="Headlight Restoration Services Restores clarity to headlights that have become foggy. "
          src="https://raw.githubusercontent.com/AsmaJalal/mycarmedics/main/MyCarmedics_website_MERN_STACK/screenshots/MyCarmedicswebsite.gif"
        />

        <ProjectsCard
          title="MyCarmedics Mobile App"
          des="Headlight Restoration discolored, yellowed due to sun damage environmental factors."
          src="https://raw.githubusercontent.com/AsmaJalal/MyCarmedicsMobile/main/car.gif"
        />

        <ProjectsCard
          title="E-commerce App"
          des="An E-commerce website configureStore. home page or a dedicated products page ."
          src="https://raw.githubusercontent.com/AsmaJalal/online-shopping-app/master/public/images/ecom.gif"
        />

        <ProjectsCard
          title="Food Recipe App"
          des="The app including ingredients, creator details, and cooking instructions."
          src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/fooddil.gif"
        />

        <ProjectsCard
          title="SOCIAL MEDIA"
          des="Lorem, ipsum dolor sit amet consectetur adipisicing elit. !"
          src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/socil.gif"
        />

        <ProjectsCard
          title="Food Recipe"
          des="The app including ingredients, creator details, and cooking instructions."
          src="https://raw.githubusercontent.com/AsmaJalal/My_Recipe_App_React_Native/main/src/Screenshots/Animation2.gif"
        />
        <ProjectsCard
          title="business-card-react"
          des="Business Card React App!"
           src="https://raw.githubusercontent.com/AsmaJalal/business-card-react/master/src/images/2.png"
        />
        <ProjectsCard
          title="TMDB"
          des="movie app for upcoming movies shows Lists of movies, Tv Shows and details of each movie."
           src="https://raw.githubusercontent.com/AsmaJalal/TMDB/main/a210419a-35ba-4446-99e8-af412ca35600.jpeg"
        />
         <ProjectsCard
          title="react-spa-with-pwa-weather"
          des="user-friendly weather app powered by the OpenWeather API, providing Single Page App."
           src="https://raw.githubusercontent.com/AsmaJalal/react-spa-with-pwa-weather/master/weather.png"
        />
         
      </div>
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      {/* <div className="grid grid-cols-1 md:grid-cols-1 xl:grid-cols-1 gap-6 xl:gap-14">
        <ProjectsCardedit
          title="Open to work "
          des="Asma jalal"
          src="https://firebasestorage.googleapis.com/v0/b/testingapps-7c1cd.appspot.com/o/Profileimage.gif?alt=media&token=0e1796a6-9405-4cf7-ad39-4fea6f67c4cc"
        />
      </div> */}
    </section>
  );
};

export default Projects;
